import { _quatFromRotationBasis } from './quat-from-rotation-matrix.js';
import { mat4Determinant3 } from './mat4-determinant3.js';

function mat4Decompose(m) {
  const sx = Math.hypot(m[0], m[1], m[2]);
  const syAbs = Math.hypot(m[4], m[5], m[6]);
  const sz = Math.hypot(m[8], m[9], m[10]);
  const sy = mat4Determinant3(m) < 0 ? -syAbs : syAbs;
  const invSx = sx > 1e-8 ? 1 / sx : 0;
  const invSy = syAbs > 1e-8 ? 1 / sy : 0;
  const invSz = sz > 1e-8 ? 1 / sz : 0;
  const q = _quatFromRotationBasis(m[0] * invSx, m[4] * invSy, m[8] * invSz, m[1] * invSx, m[5] * invSy, m[9] * invSz, m[2] * invSx, m[6] * invSy, m[10] * invSz);
  const invLen = 1 / Math.hypot(q.x, q.y, q.z, q.w);
  return {
    translation: { x: m[12], y: m[13], z: m[14] },
    rotation: { x: q.x * invLen, y: q.y * invLen, z: q.z * invLen, w: q.w * invLen },
    scale: { x: sx, y: sy, z: sz }
  };
}

export { mat4Decompose };
//# sourceMappingURL=mat4-decompose.js.map
